import { supabase, productsService, ordersService } from './supabase';

export const productService = {
  getAll: async () => {
    try {
      const products = await productsService.getAll();
      return { data: { products } };
    } catch (error) {
      throw error;
    }
  },
  
  getById: async (id) => {
    try {
      const product = await productsService.getById(id);
      return { data: { product } };
    } catch (error) {
      throw error;
    }
  },
};

export const orderService = {
  create: async (orderData) => {
    try {
      const order = await ordersService.create(orderData);
      return { data: order };
    } catch (error) {
      throw error;
    }
  },
  
  getById: async (orderNumber, email) => {
    try {
      const order = await ordersService.getByOrderNumber(orderNumber, email);
      return { data: { order } };
    } catch (error) {
      throw error;
    }
  },
};

export { supabase };
export default supabase;
